import { render, staticRenderFns } from "./requestSets.vue?vue&type=template&id=dd3a547a"
import script from "./requestSets.vue?vue&type=script&lang=js"
export * from "./requestSets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports